import React from "react";
import { markdown } from "markdown";

export default ({ sectionName, textContent: { textContent } }) => (
  <section
    className="colorlib-about"
    data-section={sectionName.replace(/[^a-zA-Z0-9]/, "-")}
  >
    <div className="colorlib-narrow-content">
      <div className="row">
        <div className="col-md-12">
          <div className="row row-bottom-padded-sm">
            <div className="col-md-12">
              <div className="about-desc">
                <span className="heading-meta">{sectionName}</span>
                <div
                  dangerouslySetInnerHTML={{
                    __html: markdown.toHTML(textContent)
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);



// WEBPACK FOOTER //
// ./src/components/textContent.js